"use strict";
exports.__esModule = true;
exports.BroadcastKeys = void 0;
var angular = require("angular");
require('./global-tables.component.css');
var saveBolb = (function () {
    var a = document.createElement("a");
    a.style.cssText = "display: none !important";
    document.body.appendChild(a);
    return function (blob, fileName) {
        var url = window.URL.createObjectURL(blob.data);
        a.href = url;
        a.download = fileName;
        a.click();
        window.URL.revokeObjectURL(url);
    };
})();
var COMPONENT_NAME = 'smartorg.r6.mgmt.globalTables';
exports.BroadcastKeys = {
    INIT: 'globalTables:INIT'
};
var GlobalTablesComponent = /** @class */ (function () {
    function GlobalTablesComponent($scope, $timeout, $http) {
        var _this = this;
        this.$scope = $scope;
        this.$timeout = $timeout;
        this.$http = $http;
        $scope.$on(exports.BroadcastKeys.INIT, function () {
            _this.displayTableList();
        });
    }
    GlobalTablesComponent.prototype.back = function () {
        this.$scope.$emit('workbench:back');
    };
    GlobalTablesComponent.prototype.clearFileSelect = function () {
        this.selectedFile = null;
        document.querySelector("input[type='file']").value = null;
    };
    GlobalTablesComponent.prototype.selectTable = function (tableName) {
        this.selectedTable = tableName;
        this.newTableName = tableName;
        this.clearFileSelect();
        this.previewTable();
    };
    GlobalTablesComponent.prototype.previewTable = function () {
        var _this = this;
        var ctrl = this;
        ctrl.selectedTablePreview = null;
        ctrl.selectedTableFileName = null;
        ctrl.smartorgApi.previewGlobalTable(ctrl.selectedTable).then(function (response) {
            console.log('PREVIEW', response);
            var colDefs = undefined;
            if (response.columns) {
                colDefs = response.columns.map(function (key) { return ({
                    displayName: key,
                    field: btoa(key),
                    minWidth: 100
                }); });
            }
            ctrl.savedOn = 'savedOn' in response ? response.savedOn : '';
            ctrl.savedBy = 'savedBy' in response ? response.savedBy : '';
            ctrl.selectedTablePreview = {
                columnDefs: colDefs,
                data: response.data.map(function (row) {
                    var newRow = {};
                    Object.entries(row).forEach(function (_a) {
                        var k = _a[0], v = _a[1];
                        newRow[btoa(k)] = v;
                    });
                    return newRow;
                })
            };
            ctrl.selectedTableFileName = response.filename;
            _this.$timeout();
        })["catch"](function (err) {
            ctrl.showAlert({
                type: 'danger',
                title: 'Failed to load preview!',
                message: err.message
            });
        });
    };
    GlobalTablesComponent.prototype.downloadExcel = function () {
        var _this = this;
        var ctrl = this;
        ctrl.smartorgApi.downloadGlobalTables(ctrl.$http, ctrl.selectedTable).then(function (response) {
            saveBolb(response, _this.selectedTableFileName);
        })["catch"](function (err) {
            ctrl.showAlert({
                type: 'danger',
                title: 'Failed to download excel file!',
                message: err.message
            });
        });
    };
    GlobalTablesComponent.prototype.clearUp = function () {
        this.selectedTable = null;
        this.newTableName = null;
        this.selectedTablePreview = null;
        this.selectedTableFileName = null;
        this.clearFileSelect();
    };
    GlobalTablesComponent.prototype.displayTableList = function () {
        var ctrl = this;
        this.clearUp();
        this.smartorgApi.getListOfGlobalTables().then(function (tableList) {
            ctrl.tableList = tableList;
            ctrl.$timeout();
        })["catch"](function (err) {
            console.error(err);
        });
    };
    GlobalTablesComponent.prototype.uploadExcel = function () {
        var ctrl = this;
        ctrl.uploading = true;
        this.smartorgApi.uploadGlobalTableExcel(this.newTableName, this.selectedFile).then(function (response) {
            if (response.status === 201) {
                var tableName = ctrl.newTableName;
                ctrl.newTableName = null;
                ctrl.selectedFile = null;
                ctrl.displayTableList();
                ctrl.selectTable(tableName);
                ctrl.showAlert({
                    type: 'success',
                    title: 'Upload Successful!',
                    message: "Excel file has been uploaded successfully and saved as \"" + tableName + "\"."
                });
            }
            else {
                throw response;
            }
            ctrl.uploading = false;
        })["catch"](function (err) {
            ctrl.uploading = false;
            var errMsg = err.message.startsWith && err.message.startsWith('Unsupported format') ?
                "Unsupported Format. File formats supported are: xls, xlsx and xlsm only." : err.message;
            ctrl.showAlert({
                type: 'danger',
                title: 'Upload Failed!',
                message: errMsg
            });
        });
    };
    GlobalTablesComponent.prototype.confirmDelete = function (tableName) {
        var ctrl = this;
        bootbox.dialog({
            message: "Delete table <b>" + tableName + "</b>?",
            title: 'Confirm Deletion',
            buttons: {
                confirm: {
                    label: 'Delete',
                    className: 'btn-danger',
                    callback: function () {
                        ctrl.deleteGlobalTable(tableName);
                    }
                },
                cancel: {
                    label: 'Cancel',
                    className: 'btn-primary'
                }
            }
        });
    };
    GlobalTablesComponent.prototype.deleteGlobalTable = function (tableName) {
        var ctrl = this;
        this.smartorgApi.deleteGlobalTable(tableName).then(function (response) {
            if (response.status === 201) {
                ctrl.displayTableList();
                ctrl.showAlert({
                    type: 'success',
                    title: 'Delete Successful!',
                    message: "Table \"" + tableName + "\" has been deleted successfully."
                });
            }
            else {
                throw response;
            }
        })["catch"](function (err) {
            ctrl.showAlert({
                type: 'danger',
                title: 'Delete Failed!',
                message: err.message
            });
        });
    };
    return GlobalTablesComponent;
}());
angular.module(COMPONENT_NAME, [
    'ui.grid',
    'ui.grid.resizeColumns',
    'ui.grid.autoResize',
    'ui.grid.moveColumns',
]).component('globalTablesManage', {
    template: require('./global-tables.component.html'),
    bindings: {
        smartorgApi: '=',
        showAlert: '&?'
    },
    controller: GlobalTablesComponent
}).directive('fileModel', ['$parse', function ($parse) {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                var model = $parse(attrs.fileModel);
                var modelSetter = model.assign;
                element.bind('change', function () {
                    scope.$apply(function () {
                        modelSetter(scope, element[0].files[0]);
                    });
                });
            }
        };
    }]);
exports["default"] = COMPONENT_NAME;
//# sourceMappingURL=global-tables.component.js.map


// WEBPACK FOOTER //
// ./app/widgets/management/global-tables/global-tables.component.js